export default __webpack_public_path__ + "static/media/actividad-43.6298e70a.mp3";